import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewEncapsulation } from '@angular/core';
import { TopicLeaf } from '../../model/TopicLeaf';
import { ContentEntryDisplayData } from '../../model/ContentEntry/ContentEntryDisplayData';
import { ContentEntryPublishRenderDescriptor } from '../../model/ContentEntryPublishRenderDescriptor';

@Component({
  selector: 'app-courseware-topic',
  templateUrl: './courseware-topic.component.html',
  styleUrls: ['./courseware-topic.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CoursewareTopicComponent implements OnInit {
  @Input() topic: TopicLeaf;
  @Output() showContentEntry = new EventEmitter<ContentEntryDisplayData>();
  contentEntry: ContentEntryDisplayData;
  shortTopicChildrenListVisibility: boolean = true;
  longTopicChildrenListVisibility: boolean = false;
  @Input() levelOneAlias: string;
  @Input() levelTwoAlias: string;
  visibleContentEntries = new Map();
  expandedElements = new Map();
  theElement: ElementRef = null;

  constructor(myElement: ElementRef) {
    this.theElement = myElement;
  }

  ngOnInit() {
    if (this.levelTwoAlias)
      this.visibleContentEntries.set(this.levelTwoAlias, 1);
    if (this.levelOneAlias && this.levelOneAlias == this.topic.TopicInformation.Alias) {
      this.showAllChildTopics();
      //        this.theElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  onShowContentEntry(parentTopic: TopicLeaf, theContent: ContentEntryPublishRenderDescriptor) {
    //    if (this.topic == null)
    //      console.log("onShowContentEntry: topic is null" );
    this.contentEntry = ContentEntryDisplayData.InstantiateContentEntryDisplayData(this.topic, parentTopic, theContent);

    this.showContentEntry.emit(this.contentEntry);
  }

  public getIconClass(alias) {
    if (!this.visibleContentEntries.has(alias))
      return "fa fa-plus-square margin-right-5";
    return "fa fa-minus-square margin-right-5";
  }


  showAllChildTopics() {
    this.shortTopicChildrenListVisibility = false;
    this.longTopicChildrenListVisibility = true;
  }

  showContentEntries(elementToShow: string) {
    if (!this.visibleContentEntries.has(elementToShow))
      this.visibleContentEntries.set(elementToShow, 1);
    else
      this.visibleContentEntries.delete(elementToShow);
  }

  getShowContentEntries(currentElement: string, currentHtmlElement: HTMLInputElement) {
    if (this.visibleContentEntries.has(currentElement)) {
      if (this.levelTwoAlias) {
        //          currentHtmlElement.scrollIntoView();
        this.levelTwoAlias = null;
      }
      return true;
    }
    return false;
  }

  showContentEntriesFromShortTopicList(alias) {
    this.showAllChildTopics();
    this.showContentEntries(alias);
  }

  getShortTopicChildrenListVisibiliy() {
    return this.shortTopicChildrenListVisibility
  }

  getLongTopicChildrenListVisibiliy() {
    return this.longTopicChildrenListVisibility;
  }
}
